import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";
export const metadata: FigureMetadata = {
  id: "GOVVGDP",
  title: defineMessage({
    id: "fig.finance.GOVVGDP.title",
    defaultMessage: `Total public expenditure on education as a percentage of GDP and of total government expenditure`,
  }),
  caption: defineMessage({
    id: "fig.finance.GOVVGDP.caption",
    defaultMessage: `Some countries have increasingly prioritised investment in education.`,
  }),
  source: defineMessage({
    id: "fig.finance.GOVVGDP.source",
    defaultMessage: `UIS database`,
  }),
};
